import React, { useState } from "react";
import { TabPane, Button, Row, Col } from "reactstrap";
import "./index.css";
import CustomTextInput from "../../../../components/CustomTextInput";
import CustomDropdownInput from "../../../../components/CustomDropdownInput";
import MapComponent from "../../../MapComponent";
import CityPicker from "../../../../components/CityPicker";
import { Link } from "react-router-dom";

interface LocationInformationTabProps {
  isView: boolean;
  storeData: any;
  setStoreData: Function;
  sitePositionTypeOptions: any;
  siteSurroundingAreaTypeOptions: any;
}

export default function LocationInformationTab({
  isView,
  storeData,
  setStoreData,
  sitePositionTypeOptions,
  siteSurroundingAreaTypeOptions,
}: LocationInformationTabProps) {
  const [isShowMap, setIsShowMap] = useState(false);
  const updateAttr = (attribute: string, value: any) => {
    let dataUpdate = {};
    if (value?.label) {
      // Check value is object (value from dropdown menu)
      dataUpdate = {
        [attribute]: {
          id: value?.value,
          name: value?.label,
        },
      };
    } else {
      dataUpdate = { [attribute]: value };
    }
    setStoreData({
      ...storeData,
      ...{ data: { ...storeData?.data, ...dataUpdate } },
    });
  };

  const updateSiteCity = (selectedCity: any) => {
    setStoreData({
      ...storeData,
      ...{ data: { ...storeData?.data, ...selectedCity } },
    });
  };

  const toogleMap = () => {
    setIsShowMap(!isShowMap);
  };

  const uiLayoutDefinition: any = [
    {
      type: "row",
      label: "Thông tin cửa hàng",
      items: [
        { attributeName: "name", type: "text", size: 12 },
        { attributeName: "internal_code", type: "text", size: 6 },
        { attributeName: "soft_opening_date", type: "date", size: 12 },
        { attributeName: "grand_opening_date", type: "date", size: 12 },
        {
          type: "custom",
          size: 12,
          component: (
            <CityPicker
              isView={true}
              onSelect={(selectedData) => updateSiteCity(selectedData)}
              city={storeData.data.city}
              district={storeData.data.district}
              ward={storeData.data.ward}
              elementToShow={["city", "district", "ward"]}
            />
          ),
        },
        { attributeName: "latitude", type: "text", size: 6, isView: true },
        { attributeName: "longitude", type: "text", size: 6, isView: true },
        {
          attributeName: "address_number",
          type: "text",
          size: 6,
          isView: true,
        },
        { attributeName: "street_name", type: "text", size: 6, isView: true },
        {
          type: "custom",
          size: 6,
          component: (
            <Button
              outline
              color="primary"
              tag={Link}
              target="_blank"
              to={`/sitev2/${storeData?.data?.site?.id}`}
              style={styles.controlButton}
            >
              Xem thông tin mặt bằng
            </Button>
          ),
        },
        {
          type: "custom",
          size: 6,
          component: (
            <Button
              outline
              color="primary"
              onClick={toogleMap}
              style={styles.controlButton}
            >
              {isShowMap ? "Ẩn " : "Hiện "} bản đồ
            </Button>
          ),
        },
        {
          type: "custom",
          size: 12,
          component: !isShowMap ? null : (
            <div style={styles.mapDiv}>
              {isShowMap && (
                <MapComponent
                  latitude={
                    storeData.data?.latitude ||
                    storeData.data?.location?.latitude
                  }
                  longitude={
                    storeData.data?.longitude ||
                    storeData.data?.location?.longitude
                  }
                  scanningRadius={2}
                />
              )}
            </div>
          ),
        },
      ],
    },
    {
      type: "row",
      label: "Khu vực xung quanh",
      items: [
        {
          attributeName: "site_position_type",
          type: "dropdown",
          size: 6,
          options: sitePositionTypeOptions,
        },
        {
          attributeName: "primary_site_surrounding_area_type",
          type: "dropdown",
          size: 6,
          options: siteSurroundingAreaTypeOptions,
        },
        {
          attributeName: "secondary_site_surrounding_area_type",
          type: "dropdown",
          size: 6,
          options: siteSurroundingAreaTypeOptions,
        },
        { attributeName: "nearby_competitor_info", type: "textarea", size: 12 },
      ],
    },
  ];

  return (
    <TabPane tabId="location_information_tab">
      {uiLayoutDefinition.map((row: any, index: number) => (
        <div key={index}>
          <h4 className="store-summary__label-title">{row.label}</h4>
          <Row className="store-information-tab__section">
            {row.items.map((layoutItem: any, layoutIndex: number) => {
              let customAttributeData: any = {};
              if (
                storeData?.data?.custom_attribute_data &&
                storeData?.data?.custom_attribute_data !== ""
              ) {
                customAttributeData = JSON.parse(
                  storeData?.data?.custom_attribute_data
                );
              }
              if (layoutItem.type === "dropdown") {
                return (
                  <Col
                    key={`layout-${index}-${layoutIndex}`}
                    sm={{ size: layoutItem.size, offset: 0 }}
                  >
                    <CustomDropdownInput
                      disabled={layoutItem.isView || isView}
                      style={styles.customTextInput}
                      callback={updateAttr}
                      data={storeData?.data}
                      options={layoutItem.options}
                      labels={storeData?.labels}
                      attributeName={layoutItem.attributeName}
                    />
                  </Col>
                );
              } else if (
                layoutItem.type === "text" ||
                layoutItem.type === "textarea" ||
                layoutItem.type === "date"
              ) {
                return (
                  <Col
                    key={`layout-index-${layoutIndex}`}
                    sm={{ size: layoutItem.size, offset: 0 }}
                  >
                    <CustomTextInput
                      type={layoutItem.type}
                      isNumeric={layoutItem.isNumeric || false}
                      isDecimal={layoutItem.isDecimal || false}
                      disabled={layoutItem.isView || isView}
                      style={styles.customTextInput}
                      callback={updateAttr}
                      data={storeData?.data}
                      labels={storeData?.labels}
                      attributeName={layoutItem.attributeName}
                      inputBoxRows={layoutItem.inputBoxRows}
                    />
                  </Col>
                );
              } else if (layoutItem.type === "break") {
                return (
                  <Col
                    key={`layout-index-${layoutIndex}`}
                    sm={{ size: 6, offset: 0 }}
                  />
                );
              } else if (layoutItem.type === "custom") {
                return (
                  <Col
                    key={`layout-index-${layoutIndex}`}
                    sm={{ size: layoutItem.size, offset: 0 }}
                  >
                    {layoutItem.component}
                  </Col>
                );
              }
            })}
          </Row>
        </div>
      ))}
    </TabPane>
  );
}

const styles = {
  customTextInput: {},
  controlButton: {
    marginTop: 12,
    marginBottom: 12,
  },
  mapDiv: {
    minHeight: 500,
    marginTop: 12,
    marginBottom: 12,
  },
  contactView: {
    padding: 12,
  },
};
